<template>
  <div
    class="viluu-landing viluu-kennenlernen"
    :class="{ 'is-leaving': isLeaving, 'from-bfcache': fromBfcache }"
  >
    <bg-blobs />
    <svg-defs />
    <kennenlernen-nav />

    <main>
      <hero-section />
      <community-section />
      <steps-section />
      <warum-section />
      <stimmen-section />
      <faq-section />
      <cta-band />
    </main>

    <kennenlernen-footer />
    <sticky-cta />

    <signup-modal />
    <cookie-banner />
  </div>
</template>

<script>
import { landingChromeMixin } from '../landingChrome';
import BgBlobs from '../../../../components/LandingV2/BgBlobs.vue';
import CookieBanner from '../../../../components/LandingV2/CookieBanner.vue';
import SignupModal from '../../../../components/LandingV2/signup/SignupModal.vue';
import SvgDefs from '../../../../components/LandingV2/Kennenlernen/SvgDefs.vue';
import KennenlernenNav from '../../../../components/LandingV2/Kennenlernen/KennenlernenNav.vue';
import HeroSection from '../../../../components/LandingV2/Kennenlernen/HeroSection.vue';
import CommunitySection from '../../../../components/LandingV2/Kennenlernen/CommunitySection.vue';
import StepsSection from '../../../../components/LandingV2/Kennenlernen/StepsSection.vue';
import WarumSection from '../../../../components/LandingV2/Kennenlernen/WarumSection.vue';
import StimmenSection from '../../../../components/LandingV2/Kennenlernen/StimmenSection.vue';
import FaqSection from '../../../../components/LandingV2/Kennenlernen/FaqSection.vue';
import CtaBand from '../../../../components/LandingV2/Kennenlernen/CtaBand.vue';
import KennenlernenFooter from '../../../../components/LandingV2/Kennenlernen/KennenlernenFooter.vue';
import StickyCta from '../../../../components/LandingV2/Kennenlernen/StickyCta.vue';
import { initKennenlernenEffects } from '../../../../components/LandingV2/Kennenlernen/kennenlernenEffects';
import { profileImg } from '../../../../components/LandingV2/Kennenlernen/profiles';

export default {
  name: 'KennenlernenPage',
  mixins: [landingChromeMixin],
  components: {
    BgBlobs,
    CookieBanner,
    SignupModal,
    SvgDefs,
    KennenlernenNav,
    HeroSection,
    CommunitySection,
    StepsSection,
    WarumSection,
    StimmenSection,
    FaqSection,
    CtaBand,
    KennenlernenFooter,
    StickyCta,
  },
  data() {
    return {
      teardownEffects: null,
    };
  },
  mounted() {
    // Wave / pearl / quote / FAQ / duo / typing / sticky CTA — all keyed off
    // section ids that live across child components, so they run on the page root.
    this.teardownEffects = initKennenlernenEffects(this.$el, {
      profileUrl: profileImg,
    });
  },
  beforeDestroy() {
    if (typeof this.teardownEffects === 'function') {
      this.teardownEffects();
    }
  },
};
</script>
